import { boot } from 'quasar/wrappers'
import * as sdk from 'matrix-js-sdk'

// "async" is optional;
// more info on params: https://v2.quasar.dev/quasar-cli/boot-files
export default boot(async ({ app }) => {
  app.config.globalProperties.$matrix = sdk
})
